<template>
  <div v-if="error">
    Произошла ошибка. Обновите страницу.
  </div>
  <div v-else-if="!isLoad" class="mc-loader loader">
    <div class="mc-loader"><span class="mc-loader__circle"></span></div>
  </div>
  <component v-else :is="layout">
    <router-view/>
  </component>
</template>

<script>
import EmptyLayout from '@/layouts/EmptyLayout'
import MainLayout from '@/layouts/MainLayout'
import axios from 'axios'
import { userService } from '@/services/user'
import { simulatedHoverMixin } from './mixin/simulatedHoverMixin'


export default {
  data: () => ({
    isLoad: false,
  }),
  mixins: [simulatedHoverMixin],
  computed: {
    layout() {
      return (this.$route.meta.layout || 'empty') + '-layout'
    },
    error() {
      return this.$store.getters.errorRequest
    }
  },

  components: {
    EmptyLayout,
    MainLayout
  },

  async created() {


    try {
      // Загрузка данных пользователя
      const response = await userService.register()
      
      const userData = {
        ...response.data.data,
      }
      console.log(userData);
      // Устанавливаем данные пользователя в хранилище
      await this.$store.dispatch('Auth', userData)

      // Настройка интерсептора
      this.setupAxiosInterceptors()
      
      // Проверяем, есть ли необходимость в редиректе по защите маршрутов
      this.checkRouteAccess()
      
    } catch (error) {
      console.error('Ошибка инициализации:', error)
    } finally {
      this.isLoad = true
    }
  },

  methods: {
    setupAxiosInterceptors() {
      this.axios.interceptors.request.use(
          config => {
            debugger;
            const sessid = this.$store.getters.sessid

            if (sessid) {
              // Для POST/PUT/PATCH запросов с FormData
              if (config.data instanceof FormData) {
                config.data.append('sessid', sessid)
              }
              // Для GET запросов или JSON данных
              else if (config.method === 'get') {
                config.params = { ...config.params, sessid }
              }
              // Для JSON запросов
              else {
                config.data = { ...config.data, sessid }
              }
            }

            return config
          },
          error => Promise.reject(error)
      )

      this.axios.interceptors.response.use(
        response =>
        {
          debugger;
          if (response.data.sessid) {
            this.$store.commit('SET_SESSID', response.data.sessid)
          }

          if (response.data.status === 'error') {
            console.log(response.data.errors);
          }

          /*if (error.response?.status === 403) {
            // 403 может означать невалидный sessid
            this.handleExpiredSession()
          }*/

          return response;
        },
        error => {
          if (error.response?.status === 401) {
            // Теперь можно включить редирект при ошибке авторизации
            this.$store.dispatch('logout')
            this.$router.push('/auth/')
          }
          if (error.response?.status === 500) {
            this.$router.push('/notfound')
          }
          return Promise.reject(error)
        }
      )
    },
    async handleExpiredSession() {
      try {
        // Запрашиваем новый sessid
        const response = await this.axios.get('/api/user/refresh-sessid/')

        if (response.data.sessid) {
          this.$store.commit('SET_SESSID', response.data.sessid)
          // Можно показать уведомление пользователю
          console.log('Сессия обновлена')
        }
      } catch (error) {
        console.error('Не удалось обновить сессию:', error)
        // Перенаправляем на авторизацию
        this.$store.dispatch('logout')
        this.$router.push('/auth/')
      }
    },
    
    // Метод для проверки доступа к текущему маршруту после инициализации
    checkRouteAccess() {
      const currentRoute = this.$router.currentRoute.value
      // Проверяем доступ к защищенным маршрутам
      if (currentRoute.meta.requiresAuth === true && !this.$store.getters.isAuth) {
        this.$router.push('/auth/')
      } 
      // Проверяем доступ к маршрутам только для неавторизованных
      else if (currentRoute.meta.requiresAuth === false && this.$store.getters.isAuth) {
        this.$router.push('/')
      }
    }
  }
}
</script>

<style scoped>
.loader {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  text-align: center;
}

.spinner {
  height: 40px;
  border: 4px solid rgba(0, 0, 0, 0.2);
  border-radius: 50%;
  border-top-color: #ddd;
  animation: spiner 1s ease-in-out infinite;
  margin-bottom: 16px;
}



</style>